import { lazy, Suspense, useEffect, useState } from 'react'

// Dynamic import — Webpack splits this (and all of three/@react-three/*)
// into its own chunk instead of bundling it into main.js, so pages don't
// have to download/parse/execute three.js before they can paint anything.
const HeroScene3D = lazy(() => import('./HeroScene3D'))

/**
 * Renders nothing until the browser is idle (or a short fallback timeout on
 * browsers without requestIdleCallback), THEN starts fetching and mounting
 * the 3D scene. Keeps the heavy WebGL setup off the critical rendering path
 * entirely — first paint, LCP and main-thread work during load are
 * unaffected by it.
 */
export default function LazyHeroScene(props) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let idleId
    let timeoutId

    const start = () => setReady(true)

    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(start, { timeout: 2500 })
    } else {
      timeoutId = setTimeout(start, 400)
    }

    return () => {
      if (idleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(idleId)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [])

  if (!ready) return null

  return (
    <Suspense fallback={null}>
      <HeroScene3D {...props} />
    </Suspense>
  )
}
